import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import GameCard from '../../components/GameCard/GameCard';
import Image_slider from '../../components/ImageSlider/Image_slider';
import AdCMP from '../../components/ADS/AdCMP';

function BlogPreview() {
    const { name } = useParams();
    const [state, setState] = useState([]);
    const [gamesList, setGamesList] = useState([]);

    const slugify = (text) => text?.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-') || ''
    const getGameListFunc = async () => {
        const api_res = await axios.get("https://pub.gamezop.com/v3/games?id=9632&lang=en");
        const games = api_res?.data?.games || [];
        setGamesList(games)
        // const New_Data = api_res?.data?.games?.filter(
        //     (item) => item?.name?.en?.toLowerCase().replace(/\s+/g, "-") === name
        // );

        const New_Data = games.filter((item) => slugify(item?.name?.en) === name); setState(New_Data[0] || null);
    };

    useEffect(() => {
        getGameListFunc();
    }, [name]);

    useEffect(() => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, [state]);

    function formatNumber(num) {
        if (!num || num === 0) return '0';
        if (num >= 1e9) {
            return (num / 1e9).toFixed(2) + "B";
        } else if (num >= 1e6) {
            return (num / 1e6).toFixed(2) + "M";
        } else if (num >= 1e3) {
            return (num / 1e3).toFixed(2) + "K";
        }
        return num.toString();
    }


    return (
        <div className='p-4 sm:ml-56'>
            {
                state?.url &&

                <Helmet>
                    <meta charSet="utf-8" />
                    <meta name="theme-color" content="#F4F4F4" />
                    <meta name="apple-mobile-web-app-capable" content="yes" />
                    <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
                    <meta name="apple-mobile-web-app-title" content="VibeOfGames Blog" />
                    <meta name="HandheldFriendly" content="true" />
                    <meta name="mobile-web-app-capable" content="yes" />
                    <meta http-equiv="x-ua-compatible" content="ie=edge" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, minimal-ui, shrink-to-fit=no viewport-fit=cover" />

                    {/* <!-- Dynamic Blog Title --> */}
                    <title>{state?.name?.en} - VibeOfGames Blog</title>
                    <meta name="title" content={`${state?.name?.en} - VibeOfGames Blog`} />

                    {/* <!-- Dynamic Blog Description --> */}
                    <meta name="description" content={`Read about ${state?.name?.en} on VibeOfGames Blog. Stay updated with the latest gaming insights, news, and stories.`} />

                    {/* <!-- Dynamic Blog Keywords --> */}
                    <meta name="keywords" content={`${state?.blog?.tags?.join(", ") || "VibeOfGames, Blog, Online Games, Gaming News, Game Updates"}`} />

                    {/* <!-- Open Graph Metadata --> */}
                    <meta property="og:title" content={`${state?.name?.en} - VibeOfGames Blog`} />
                    <meta property="og:description" content={`Explore ${state?.name?.en} on VibeOfGames Blog.`} />
                    <meta property="og:url" content={`https://vibeofgames.com/blog/${name}`} />
                    <meta property="og:site_name" content="VibeOfGames Blog" />
                    <meta property="og:image" content={state?.assets?.thumb || "https://vibeofgames.com/logo.png"} />
                    <meta property="og:type" content="article" />

                    {/* <!-- Twitter Metadata --> */}
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`${state?.name?.en} - VibeOfGames Blog`} />
                    <meta name="twitter:description" content={`Learn about ${state?.name?.en} on VibeOfGames Blog.`} />
                    <meta name="twitter:image" content={state?.assets?.thumb || "https://vibeofgames.com/logo.png"} />

                    <link rel="canonical" href={`https://vibeofgames.com/blog/${state?.name?.en}`} />

                    <script type="application/ld+json">
                        {`
                        {
                        "@context": "https://schema.org",
                        "@type": "BlogPosting",
                        "headline": "${state?.name?.en}",
                        "description": "Read about ${state?.name?.en} on VibeOfGames Blog. Stay updated with the latest gaming insights, news, and stories.",
                        "image": "${state?.blog?.image || 'https://vibeofgames.com/logo.png'}",
                        "author": {
                            "@type": "Organization",
                            "name": "VibeOfGames"
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": "VibeOfGames",
                            "logo": {
                            "@type": "ImageObject",
                            "url": "https://vibeofgames.com/logo.png"
                            }
                        },
                        "datePublished": "${state?.blog?.publishedAt || new Date().toISOString()}",
                        "dateModified": "${state?.blog?.updatedAt || new Date().toISOString()}",
                        "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": "https://vibeofgames.com/blog/${name}"
                        }
                        }
                    `}
                    </script>

                </Helmet>

            }

            <div className="max-w-4xl mx-auto py-8 mt-5">
                {/* Title */}
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6">
                    {state?.name?.en}
                </h1>

                {/* Game Image */}
                <div className="mb-8">
                    <img
                        src={state?.assets?.thumb}
                        alt={state?.name?.en}
                        className="w-full h-64 md:h-80 object-cover rounded-lg"
                    />
                </div>

                {/* Game Link */}
                <div className="mb-8">
                    <iframe
                        src={state?.url}
                        alt={state?.name?.en}
                        className="w-full h-96 md:h-[500px] rounded-lg border"
                    />
                </div>

                {/* Tags */}
                {state?.tags?.en && (
                    <div className="flex flex-wrap gap-2 mb-6">
                        {state?.tags?.en?.map((tag, index) => (
                            <Link key={index} to={`/tag/${tag?.toLowerCase()?.replace(/ /g, '-')}`}>
                                <span className="px-3 py-1 text-sm bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded-full">
                                    {tag}
                                </span>
                            </Link>
                        ))}
                    </div>
                )}

                {/* Ad */}
                <div className="my-8 text-center">
                    <div className='hidden xl:block'>
                        <AdCMP adSize='728x90' dataAdSlot="4229378215" />
                    </div>
                    <div className='hidden md:block xl:hidden'>
                        <AdCMP adSize='468x60' dataAdSlot="4229378215" />
                    </div>
                    <div className='block md:hidden'>
                        <AdCMP adSize='320x50' dataAdSlot="4229378215" />
                    </div>
                </div>

                {/* Game Stats */}
                <div className="grid grid-cols-2 gap-4 mb-8">
                    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg text-center">
                        <div className="text-xl font-bold text-yellow-500">⭐ {state?.rating}</div>
                        <div className="text-sm text-gray-600 dark:text-gray-400">Rating</div>
                    </div>
                    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg text-center">
                        <div className="text-xl font-bold text-blue-500">{formatNumber(state?.gamePlays)}</div>
                        <div className="text-sm text-gray-600 dark:text-gray-400">Plays</div>
                    </div>
                </div>

                {/* Description */}
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                        About {state?.name?.en}
                    </h2>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                        {state?.description?.en || `${state?.name?.en} is an exciting online game that offers hours of entertainment with engaging gameplay mechanics and intuitive controls.`}
                    </p>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                        Experience the thrill of {state?.name?.en} with its captivating challenges and dynamic gameplay. This game combines strategy, skill, and quick reflexes to create an unforgettable gaming experience that will keep you coming back for more.
                    </p>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        Whether you're a casual gamer looking for a quick break or a dedicated player seeking your next gaming obsession, {state?.name?.en} delivers an experience that's both accessible and deeply engaging. Perfect for gamers of all ages!
                    </p>
                </div>

                {/* Game Features */}
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                        🎮 Key Features
                    </h2>
                    <div className="grid md:grid-cols-2 gap-4">
                        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg">
                            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🚀 Easy to Learn</h3>
                            <p className="text-gray-600 dark:text-gray-400 text-sm">
                                Jump right into the action with intuitive controls and clear gameplay mechanics.
                            </p>
                        </div>
                        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg">
                            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🏆 Challenging Gameplay</h3>
                            <p className="text-gray-600 dark:text-gray-400 text-sm">
                                Master increasingly difficult levels that test your skills and strategy.
                            </p>
                        </div>
                        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg">
                            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">📱 Cross-Platform</h3>
                            <p className="text-gray-600 dark:text-gray-400 text-sm">
                                Play seamlessly on desktop, tablet, or mobile devices anywhere, anytime.
                            </p>
                        </div>
                        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg">
                            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🎯 Addictive Fun</h3>
                            <p className="text-gray-600 dark:text-gray-400 text-sm">
                                Engaging gameplay that keeps you entertained for hours on end.
                            </p>
                        </div>
                    </div>
                </div>

                {/* How to Play */}
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                        🕹️ How to Play {state?.name?.en}
                    </h2>
                    <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 p-6 rounded-lg">
                        <ol className="space-y-3 text-gray-700 dark:text-gray-300">
                            <li className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-0.5">1</span>
                                <span>Click the play button above to start the game instantly in your browser.</span>
                            </li>
                            <li className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-0.5">2</span>
                                <span>Use your mouse, keyboard, or touch controls to navigate and interact with the game.</span>
                            </li>
                            <li className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-0.5">3</span>
                                <span>Follow the on-screen instructions and complete objectives to progress through levels.</span>
                            </li>
                            <li className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-0.5">4</span>
                                <span>Challenge yourself to achieve high scores and unlock new content!</span>
                            </li>
                        </ol>
                    </div>
                </div>

                {/* Tips & Strategies */}
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                        💡 Tips & Strategies
                    </h2>
                    <div className="bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-400 p-6 rounded-r-lg">
                        <div className="space-y-3 text-gray-700 dark:text-gray-300">
                            <p><strong>🎯 Master the Basics:</strong> Take time to understand the core mechanics before attempting advanced strategies.</p>
                            <p><strong>⚡ Practice Makes Perfect:</strong> Regular play sessions will help you develop muscle memory and improve reaction times.</p>
                            <p><strong>🧠 Think Ahead:</strong> Plan your moves strategically rather than relying solely on quick reflexes.</p>
                            <p><strong>🔄 Learn from Mistakes:</strong> Each failure is a learning opportunity to improve your gameplay approach.</p>
                        </div>
                    </div>
                </div>

                {/* Screenshots */}
                {state?.assets?.screens && (
                    <div className="mb-8">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Screenshots</h2>
                        <Image_slider screens={state?.assets?.screens} />
                    </div>
                )}

                {/* Categories */}
                {state?.categories?.en && (
                    <div className="mb-8">
                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Game Categories</h3>
                        <div className="flex flex-wrap gap-2">
                            {state?.categories?.en?.map((category, index) => (
                                <span
                                    key={index}
                                    className="px-3 py-1 text-sm bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-full"
                                >
                                    {category}
                                </span>
                            ))}
                        </div>
                    </div>
                )}

                {/* Why Play This Game */}
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                        🌟 Why Play {state?.name?.en}?
                    </h2>
                    <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 p-6 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-6">
                            <div>
                                <h3 className="font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                                    <span className="text-lg mr-2">🎨</span>
                                    Engaging Visuals
                                </h3>
                                <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
                                    Stunning graphics and smooth animations create an immersive gaming experience that captivates players from the first moment.
                                </p>
                                <h3 className="font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                                    <span className="text-lg mr-2">⚡</span>
                                    Instant Fun
                                </h3>
                                <p className="text-gray-600 dark:text-gray-400 text-sm">
                                    No downloads or installations required. Jump straight into the action with just one click!
                                </p>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                                    <span className="text-lg mr-2">🏅</span>
                                    Skill Development
                                </h3>
                                <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
                                    Improve your reflexes, strategic thinking, and problem-solving abilities while having fun.
                                </p>
                                <h3 className="font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                                    <span className="text-lg mr-2">🌍</span>
                                    Global Community
                                </h3>
                                <p className="text-gray-600 dark:text-gray-400 text-sm">
                                    Join millions of players worldwide who enjoy this amazing gaming experience daily.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Gameplay Preview */}
                {state?.gamePreviews?.en && (
                    <div className="mb-8">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Gameplay Preview</h2>
                        <iframe
                            src={state?.gamePreviews?.en.replace("youtu.be/", "www.youtube.com/embed/")}
                            title={`${state?.name?.en} Preview`}
                            className="w-full h-64 md:h-96 rounded-lg"
                            allowFullScreen
                        ></iframe>
                    </div>
                )}
            </div>

            {/* Ad */}
            <div className="my-8 text-center">
                <div className='hidden xl:block'>
                    <AdCMP adSize='728x90' dataAdSlot="6784508920" />
                </div>
                <div className='hidden md:block xl:hidden'>
                    <AdCMP adSize='468x60' dataAdSlot="6784508920" />
                </div>
                <div className='block md:hidden'>
                    <AdCMP adSize='320x50' dataAdSlot="6784508920" />
                </div>
            </div>

            {/* Final Thoughts */}
            <div className="mb-12">
                <div className="bg-gradient-to-r from-gray-900 to-gray-700 dark:from-gray-800 dark:to-gray-900 text-white p-8 rounded-lg">
                    <h2 className="text-2xl font-bold mb-4 flex items-center">
                        <span className="text-2xl mr-3">🎯</span>
                        Ready to Play {state?.name?.en}?
                    </h2>
                    <p className="text-gray-200 mb-6 leading-relaxed">
                        Don't wait any longer! Experience the excitement and challenge of {state?.name?.en} right now. 
                        With its engaging gameplay, stunning visuals, and addictive mechanics, this game is sure to become 
                        your new favorite. Click the game above and start your adventure today!
                    </p>
                    <div className="flex flex-wrap gap-4 text-sm">
                        <span className="bg-green-500 px-3 py-1 rounded-full">✅ Free to Play</span>
                        <span className="bg-blue-500 px-3 py-1 rounded-full">📱 Mobile Friendly</span>
                        <span className="bg-purple-500 px-3 py-1 rounded-full">🚀 No Download Required</span>
                        <span className="bg-orange-500 px-3 py-1 rounded-full">⚡ Instant Play</span>
                    </div>
                </div>
            </div>

            {/* Related Games */}
            <div className='mt-12'>
                <h2 className='text-black dark:text-white font-bold text-2xl mb-6 flex items-center'>
                    <span className='text-2xl mr-3'>🎮</span>
                    More Games You'll Love
                </h2>
                <p className='text-gray-600 dark:text-gray-400 mb-6'>Discover more exciting games similar to {state?.name?.en}</p>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                    {gamesList && gamesList?.slice(50, 62)?.map((_ele, i) => {
                        if (!_ele?.name?.en) return null;
                        const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                        return (
                            <GameCard key={`related-${i}`} id={i} slug={GetSlug} name={_ele?.name?.en} banner={_ele?.assets?.square} link={_ele?.URL} />
                        )
                    })}
                    {gamesList.length === 0 && 
                        <div className="col-span-full bg-gray-100 dark:bg-gray-700 rounded-xl p-8 text-center">
                            <h3 className='text-xl font-semibold text-gray-700 dark:text-gray-300'>
                                Loading more games...
                            </h3>
                        </div>
                    }
                </div>
            </div>

            {/* Final Ad */}
            <div className="my-8 text-center">
                <div className='hidden xl:block'>
                    <AdCMP adSize='728x90' dataAdSlot="6200935433" />
                </div>
                <div className='hidden md:block xl:hidden'>
                    <AdCMP adSize='468x60' dataAdSlot="6200935433" />
                </div>
                <div className='block md:hidden'>
                    <AdCMP adSize='320x50' dataAdSlot="6200935433" />
                </div>
            </div>
        </div>
    );
}

export default BlogPreview;
